var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useContext, useEffect, useLayoutEffect, useMemo, useState } from 'react';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { useTourDescriptionStore, useTourExtras } from '../../store/TourDescriptionStore';
import TourDescription from './TourDescription';
import { GlobalSpinnerContext } from 'react-components/GlobalSpinnerProvider';
import TourSearchResultsHeader from '../TourSearchResults/TourSearchResultsHeader';
import { tourDetailsUrlRR } from '../../tour-urlgen';
//import { tourDetailsUrlRR, useTourUrlgen } from '../../tour-urlgen';
import { parseInt } from 'lodash';
import _ from 'lodash';
import { useSnackbar } from 'notistack';
import { Typography } from '@material-ui/core';
import { appUrl } from '../../../../include/utils';
/**
 * Контейнер описания тура, реализующий перезагрузку данных тура при изменении
 * входных параметров.
 */
export default function TourDescriptionContainer({ isFrame, bookCallback, style }) {
    const params = useParams();
    const snackbar = useSnackbar();
    const spinner = useContext(GlobalSpinnerContext);
    const [{ tourDescription: tour, tourVariant, currentAccommodationVariants: accmmds, loading, loaded, tourServices, frameId, hash, hasAccommodation, externalFlight, externalFlightId, externalFlightProviderId, search: searchUrl }, actions] = useTourDescriptionStore(isFrame);
    const [{ extras, price }] = useTourExtras(isFrame);
    const hotelServices = useMemo(() => tourServices === null || tourServices === void 0 ? void 0 : tourServices.filter(s => s.type == "hotel").map(s => s), [tourServices]);
    const excursionServices = useMemo(() => tourServices === null || tourServices === void 0 ? void 0 : tourServices.filter(s => s.type == "excursion").map(s => s), [tourServices]);
    const excursionServicesString = useMemo(() => (excursionServices === null || excursionServices === void 0 ? void 0 : excursionServices.length) > 0 ? excursionServices.map(e => `${e.id}__${e.beginDate}=${(e.currentVehicleTypeId == undefined ? '' : e.currentVehicleTypeId)}`).reduce((pr, curr) => `${pr};${curr}`) : "", [tourServices]);
    const [hashBlackList, setHashBlackList] = useState([]);
    const [prevHash, setPrevHash] = useState();
    const history = useHistory();
    const { pathname, search, state: historyState, hash: anchor, } = useLocation();
    useEffect(() => {
        const searchParams = new URLSearchParams(search);
        const flightId = searchParams.get('fId') || undefined;
        const fpId = searchParams.get('fpId');
        const flightProviderId = fpId ? parseInt(fpId) : undefined;
        const tourVariantId = searchParams.get('variant') || undefined;
        const accmmdVariantId = searchParams.get('accmmd') || undefined;
        const accmmdVariantIds = _.filter([...searchParams], x => _.startsWith(x[0], 'accmmd')).map(x => x[1]) || undefined;
        const hotelId = searchParams.get('hid');
        const tourId = parseInt(params['id']);
        const tourHash = params['hash'];
        const tourSearch = searchParams.get('search') || undefined;
        //hack: когда params не прогрузился редиректит на страницу не фрейма, поэтому юзаю pathname
        const frameParId = isFrame ? (params['frameId'] || pathname.split("/")[2]) : undefined;
        const tempFrameParId = isFrame ? (searchParams.get('tempId') || undefined) : undefined;
        const excursions = searchParams.get('exc') || undefined;
        (() => __awaiter(this, void 0, void 0, function* () {
            if (tourHash) {
                if (!prevHash || prevHash !== tourHash) {
                    yield actions.enableLoading();
                    let errors = yield actions.loadDescription({ hash: tourHash, search: tourSearch, frameId: frameParId, tempFrameId: tempFrameParId, excursions, externalFlight: flightId && flightProviderId ? { flightId, providerId: flightProviderId } : undefined });
                    if (errors === null || errors === void 0 ? void 0 : errors.length) {
                        snackbar.enqueueSnackbar(React.createElement(Typography, null,
                            "\u0420\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u044B \u043F\u043E\u0438\u0441\u043A\u0430 \u043C\u043E\u0433\u043B\u0438 \u0443\u0441\u0442\u0430\u0440\u0435\u0442\u044C. \u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u043F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u043F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u044C ",
                            React.createElement("a", { href: searchUrl !== null && searchUrl !== void 0 ? searchUrl : appUrl("/Tour") }, "\u043F\u043E\u0438\u0441\u043A"),
                            "."), { variant: 'error', autoHideDuration: null });
                        return;
                    }
                    yield actions.loadAccommodationVariants();
                    yield actions.loadHotelRecommendations();
                    yield actions.loadExternalFlight(flightId, flightProviderId);
                    yield actions.disableLoading();
                }
            }
            else if (tourId) {
                if ((tour === null || tour === void 0 ? void 0 : tour.id) != tourId) {
                    yield actions.enableLoading();
                    yield actions.loadDescription({ tourId, hotelId: (hotelId ? parseInt(hotelId) : null) || undefined, frameId: frameParId, tempFrameId: tempFrameParId, excursions, externalFlight: flightId && flightProviderId ? { flightId, providerId: flightProviderId } : undefined });
                    yield actions.disableLoading();
                }
            }
            else {
                console.error('Bad query params', { tourId, variantId: tourVariantId, accmmdId: accmmdVariantId, hotelId });
            }
        }))();
    }, [pathname, search, params['id'], params['frameId'], params['hash']]);
    // Обновление урла при изменении опций тура.
    useEffect(() => {
        if (!tour)
            return;
        //if (prevHash && prevHash !== params['hash'])
        //    setHashBlackList(prev => ([...prev, prevHash]));
        setPrevHash(params['hash']);
        const state = tourDetailsUrlRR(tour.id, {
            tourName: tour.name,
            variantId: tourVariant === null || tourVariant === void 0 ? void 0 : tourVariant.id,
            accmmdId: accmmds.map(hs => { var _a; return ((_a = hs.accommodation) === null || _a === void 0 ? void 0 : _a.id) || ''; }).filter(x => x),
            state: historyState,
            excursions: excursionServices === null || excursionServices === void 0 ? void 0 : excursionServices.map(s => ({ id: s.id, vehicleTypeId: s.currentVehicleTypeId })),
            //hash: price?.servicesHash ?? hash,
            hash: hash,
            externalFlight: externalFlight !== null && externalFlight !== void 0 ? externalFlight : (externalFlightId && externalFlightProviderId ? { flightId: externalFlightId, providerId: externalFlightProviderId } : undefined),
            extras: extras,
            search: searchUrl,
            anchor: anchor,
        }, (frameId || params['frameId'] || (pathname.split("/")[1] == "frame" ? pathname.split("/")[2] : undefined)));
        history.replace(state);
    }, [tour === null || tour === void 0 ? void 0 : tour.id, tourVariant === null || tourVariant === void 0 ? void 0 : tourVariant.id, accmmds, excursionServicesString, !isFrame ? undefined : frameId, !isFrame ? undefined : params['frameId'], !isFrame ? undefined : pathname, hotelServices, hash, externalFlight, externalFlightId, externalFlightProviderId]);
    useLayoutEffect(() => {
        if (!tour || loading)
            spinner.show();
        else
            spinner.hide();
    }, [!tour, loading]);
    useEffect(() => {
        console.log(actions.getTourCost());
    }, [extras, price === null || price === void 0 ? void 0 : price.services, price === null || price === void 0 ? void 0 : price.aviacenterServices, price === null || price === void 0 ? void 0 : price.defaultAirServices, excursionServicesString]);
    return (React.createElement(React.Fragment, null,
        typeof historyState == 'object' && historyState.searchQuery && historyState.searchResult && !isFrame
            ? React.createElement(TourSearchResultsHeader, { searchQuery: historyState.searchQuery, searchResult: historyState.searchResult, variant: "description" })
            : null,
        tour && loaded ? React.createElement(TourDescription, { isFrame: isFrame, bookCallback: bookCallback, style: style, hash: hash }) : null));
}
